import { render } from "./UserNavigationItems.vue?vue&type=template&id=1011ef41"
import script from "./UserNavigationItems.vue?vue&type=script&lang=js"
export * from "./UserNavigationItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__